import { api } from './api';
import type { ApiResponse, DashboardStats, DashboardChartData } from '../types';

export const dashboardService = {
  getStats: async (period?: string, domainId?: string | null): Promise<ApiResponse<DashboardStats>> => {
    const params = new URLSearchParams();
    if (period) params.set('period', period);
    if (domainId) params.set('domain_id', domainId);
    const qs = params.toString();
    const response = await api.get(`/dashboard/stats${qs ? `?${qs}` : ''}`);
    return response.data;
  },

  getChart: async (period: number = 30, domainId?: string | null): Promise<ApiResponse<DashboardChartData>> => {
    const params = new URLSearchParams({ period: String(period) });
    if (domainId) params.set('domain_id', domainId);
    const response = await api.get(`/dashboard/chart?${params.toString()}`);
    return response.data;
  },
};
